<template>
  <div class="custom-select-wrapper">
    <select
      :value="modelValue"
      class="custom-select"
      @change="handleChange"
    >
      <option
        v-if="placeholder"
        value=""
      >
        {{ placeholder }}
      </option>
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>
  
  <script setup lang="ts">
import { withDefaults, defineProps, defineEmits } from "vue";

interface Option {
  label: string;
  value: string | number;
}

withDefaults(defineProps<{
  modelValue: string | number;
  options: Option[];
  placeholder?: string;
}>(), {
  placeholder: 'All Games',
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string | number): void;
}>();

const handleChange = (event: Event) => {
  const target = event.target as HTMLSelectElement;
  emit("update:modelValue", target.value);
};
</script>
  
  <style scoped>
.custom-select-wrapper {
  position: relative;
  width: 100%;
}

.custom-select {
  width: 100%;
  background: var(--colour-surface-cont-lowest);
  border-radius: var(--results-filter-radius, 8px);
  border: 1px solid var(--colour-surface-cont);
  color: var(--colour-base-text-colour);
  font-family: var(--typography-font-family, "Ubuntu", sans-serif);
  font-size: 16px;
  font-weight: 500;
  padding: 0 48px 0 16px;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: 50px;
  text-align: center;
  text-align-last: center;
  background-image: var(--bg-filter-select-img, url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L7 7L13 1' stroke='%23333333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"));
  background-repeat: no-repeat;
  background-position: right 20px center;
  box-shadow: none;
  transition: none;
}

.custom-select:focus {
  border-color: var(--filter-select-focus-border-color, var(--colour-surface-cont));
  outline: var(--filter-select-focus-outline, none);
}

@media (max-width: 768px) {
  .custom-select {
    height: 44px;
    font-size: 14px;
  }
}
</style>
  
